// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminHeading-adminHeaderContainer-sQRDF {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 10px;
    z-index: 1030;
    background-color: var(--background-primary);
    padding: 16px 24px;
    position: fixed;
    top: 0;
    left: var(--siteAdmin-sideBar-width);
    right: 0;
    height: var(--siteAdmin-header-height);
    border-bottom: 1px solid var(--primary-border);
    max-width: calc(100% - var(--siteAdmin-sideBar-width));
    width: 100%;
}

.AdminHeading-adminHamburgIconContainer-ClI2s {
    background: unset;
    border: unset;
    outline: unset !important;
    width: 30px;
    height: 30px;
    padding: 0;
    display: none;

}

.AdminHeading-adminHamburgIconContainer-ClI2s svg {
    width: 100%;
    height: 100%;
    color: var(--primary-foreground);
}

@media (max-width:1199px) {
    .AdminHeading-adminHamburgIconContainer-ClI2s {
        display: block;
    }

    .AdminHeading-adminHeaderContainer-sQRDF {
        max-width: 100%;
        left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/AdminHeading.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,oCAAoC;IACpC,QAAQ;IACR,sCAAsC;IACtC,8CAA8C;IAC9C,sDAAsD;IACtD,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;;AAEjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,OAAO;IACX;AACJ","sourcesContent":[".adminHeaderContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    z-index: 1030;\n    background-color: var(--background-primary);\n    padding: 16px 24px;\n    position: fixed;\n    top: 0;\n    left: var(--siteAdmin-sideBar-width);\n    right: 0;\n    height: var(--siteAdmin-header-height);\n    border-bottom: 1px solid var(--primary-border);\n    max-width: calc(100% - var(--siteAdmin-sideBar-width));\n    width: 100%;\n}\n\n.adminHamburgIconContainer {\n    background: unset;\n    border: unset;\n    outline: unset !important;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n    display: none;\n\n}\n\n.adminHamburgIconContainer svg {\n    width: 100%;\n    height: 100%;\n    color: var(--primary-foreground);\n}\n\n@media (max-width:1199px) {\n    .adminHamburgIconContainer {\n        display: block;\n    }\n\n    .adminHeaderContainer {\n        max-width: 100%;\n        left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminHeaderContainer": `AdminHeading-adminHeaderContainer-sQRDF`,
	"adminHamburgIconContainer": `AdminHeading-adminHamburgIconContainer-ClI2s`
};
module.exports = ___CSS_LOADER_EXPORT___;
